angular.module('unergie.main')
.directive('userInfoContractDraftInformation', ($state, ApiUser, PrmUtilsService, DraftsBasic, ModalService,
    BoFeaturesService, DataAccess, OfferService, AdminComments, ErrorCatcher, RootAccountActions, AlertManager, MetaWatcher, DataAccessRefPromo
) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractDraftInformation.html',
        link($scope) {
            const canTransformContract = BoFeaturesService.isFeatureOn('canTransformContract')
            $scope.canChangeOffer = BoFeaturesService.isFeatureOn('canChangeOffer')
            $scope.canModifyConsents = BoFeaturesService.isFeatureOn('canModifyConsents')
            $scope.pot = BoFeaturesService.isFeatureOn('pot')

            $scope.deleteDraft = () =>
                DataAccess.deleteDraft({ id: $scope.contractDraft.id }).$promise.then(() => {
                    AlertManager.success('Draft supprimé')
                    MetaWatcher.notif('CONTRACT_DRAFT_CHANGED', { id: $scope.contractDraft.id })
                }).catch(ErrorCatcher)

            $scope.canTransform = () => {
                return canTransformContract &&
                $scope.contractDraft.status === 0 &&
                ((!$scope.account.billingaccount.revoked && $scope.account.billingaccount.hasMandate) || $scope.account.billingaccount.hasCardAlias) &&
                $scope.contractDraft.id_prm &&
                $scope.contractDraft.checkout_mail_sent
            }

            $scope.canTransformWithoutMeanOfPayment = () => {
                return canTransformContract &&
                $scope.contractDraft.status === 0 &&
                $scope.contractDraft.bulk_purchase &&
                $scope.contractDraft.id_prm &&
                $scope.contractDraft.checkout_mail_sent &&
                !$scope.account.billingaccount.hasMandate &&
                !$scope.account.billingaccount.hasCardAlias
            }

            $scope.podFields = {
                label: {
                    label: `<span class="red fa fa-warning"></span><span class="red"> Attention le client devra s'acquitter chaque mois de ses paiements par CB ou Chèque.</span>`,
                    type: 'label',
                },
            }

            $scope.isMigratedLinky = () => PrmUtilsService.isMigratedLinky($scope.contractDraft.prm)

            $scope.transformDraft = () => {
                $scope.transforming = true
                return ApiUser.transformDraft({ id_draft: $scope.contractDraft.id }, {}).$promise.then(() => {
                    AlertManager.success('Draft transformé en contrat')
                    $state.go('userInfoOnContract', { customerId: $scope.account.customer_id, contractId: $scope.contractDraft.id }, { reload: true })
                }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.transforming = false
                })
            }

            $scope.changeDraftOfferFields = {
                provider_offer: {
                    label: 'Offre fournisseur',
                    required: true,
                    type: 'select',
                    enum: [],
                },
            }
            $scope.changeDraftOfferPayload = {
                provider_offer: $scope.contractDraft.provider_offer,
            }

            OfferService.selectableOffersPromise.then((mapping) => {
                $scope.changeDraftOfferFields.provider_offer.enum = mapping
            })

            $scope.changeDraftOffer = () => {
                const oldOffer = $scope.contractDraft.provider_offer
                return DataAccess.modifyDraftOffer({ id_contract: $scope.contractDraft.id }, $scope.changeDraftOfferPayload).$promise.then(() => {
                    AlertManager.success('Offre modifiée')
                    const comment = `Offre modifiée : <b>${oldOffer}</b> => <b>${$scope.changeDraftOfferPayload.provider_offer}</b>`
                    AdminComments.addComment({ object: $scope.contractDraft.id, comment }).$promise.catch(ErrorCatcher)
                    MetaWatcher.notif('CONTRACT_DRAFT_CHANGED', { id: $scope.contractDraft.id })
                }).catch(ErrorCatcher)
            }

            $scope.openDraft = (draft) => {
                return DraftsBasic.getDraftBasicIdForDraftElec({ id: draft.id }).$promise
                .then((result) => {
                    const url = $state.href('salesTunnelV3', { draft: result.id_draft_basic })
                    window.open(url, '_blank')
                })
                .catch(ErrorCatcher)
            }

            $scope.getDraftConsents = () => {
                return DraftsBasic.getDraftBasicIdForDraftElec({ id: $scope.contractDraft.id }).$promise
                .then((result) => {
                    return DataAccess.getDraftConsents({ id_draft_basic: result.id_draft_basic, step: 'SUBSCRIPTION' }).$promise
                    .then((consents) => {
                        $scope.dataConsents = consents
                    })
                })
                .catch(ErrorCatcher)
            }

            $scope.getDraftConsents()

            $scope.openDraftConsentsModal = () =>
                ModalService.openModal({ type: 'contractConsentsModal', size: 'lg' }, { contract: null, draft: $scope.contractDraft }, () => $scope.getDraftConsents())
        },
    }))
